import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t mt-auto">
      <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-muted-foreground">
        <span>© 2025 GiftMe</span>
        <div className="flex items-center gap-4">
          <a 
            href="https://www.instagram.com/giftme.fr_/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-primary transition-colors"
            aria-label="Instagram GiftMe"
          >
            <Instagram className="w-5 h-5" />
          </a>
          <Link 
            to="/privacy" 
            className="hover:text-primary hover:underline transition-colors"
          >
            Politique de confidentialité
          </Link>
        </div>
      </div>
    </footer>
  );
}
